<template>
  <div class="attend-dash">
    <attend-table v-if="empAttends" :empAttends="empAttends" />
  </div>
</template>

<script>
import AttendTable from '@/components/Tables/AttendTable';
import { getDateUTC } from '../services/timeUtils';
export default {
  components: {
    AttendTable
  },
  created() {
    this.loadAttends();
  },
  methods: {
    loadAttends() {
      this.$store.dispatch({ type: 'loadTodayAttend' });
    }
  },
  computed: {
    empAttends() {
      return this.$store.getters.activeEmpAttends;
    }
  }
}
</script>

<style></style>